import {GrouperDTOResponse} from "./GrouperDTOResponse";

export class FolderDTOResponse extends GrouperDTOResponse{
  type: string;
}
